import { Pipe, PipeTransform } from '@angular/core';
import { NgStyleInput } from 'src/app/main-module/util/color-util';

@Pipe({
  name: 'mergeClasses',
  standalone: false,
})
export class MergeClassesPipe implements PipeTransform {
  transform(baseClasses: NgStyleInput, additionalClasses: NgStyleInput): NgStyleInput {
    return {
      ...baseClasses,
      ...additionalClasses,
    };
  }
}
